import { FC, useDeferredValue } from 'react';
import { ResultSelection, SortingInfo } from '../Types';
import { RouteStopsTable } from './RouteStopsTable';
import { FindStopByLineInfo } from './useFindLinesByStopSearch';

type LineRoutesListingProps = {
  readonly line: FindStopByLineInfo;
  readonly observationDate: Temporal.PlainDate;
  readonly sortingInfo: SortingInfo;
  readonly selection: ResultSelection;
};

export const LineRoutesListing: FC<LineRoutesListingProps> = ({
  line,
  observationDate,
  sortingInfo,
  selection,
}) => {
  // Rendering all the routes into tables is a slow process.
  // Show a spinner while React is doing the rendering.
  const lineTransitionInProgress = line !== useDeferredValue(line);

  return (
    <>
      {line.line_routes.map((route) => (
        <RouteStopsTable
          className="mt-6"
          key={route.route_id}
          lineTransitionInProgress={lineTransitionInProgress}
          observationDate={observationDate}
          route={route}
          sortingInfo={sortingInfo}
          selection={selection}
        />
      ))}
    </>
  );
};
